import { Grid, Paper, Stack, Typography } from '@mui/material';
import { Sensor, SensorCard } from './SensorCard';

export type SensorGroup = {
  name: string;
  description: string;
  sensors: Sensor[];
};

type Props = SensorGroup;

export const SensorsGroupCard = ({ name, description, sensors }: Props) => {
  return (
    <Paper sx={{ p: 2 }}>
      <Grid container columnSpacing={8} rowSpacing={2}>
        <Grid item xs={12} md={4}>
          <Stack gap={2}>
            <Typography variant="button">{name}</Typography>
            <Typography variant="body2">{description}</Typography>
          </Stack>
        </Grid>
        <Grid container item xs={12} md={8} spacing={2}>
          {sensors.map((s, index) => (
            <Grid key={index} item xs={12} sm={6} lg={4}>
              <SensorCard {...s} />
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Paper>
  );
};
